import { State, Action, Selector, StateContext } from '@ngxs/store';
import { SetRegionFilter, SetFormatFilter } from './tournament.actions';
import { Tournament } from './models/Tournament';

export interface TournamentStateModel {
  filters: any;
  tournaments: Tournament[];
}

const FORMAT_ICON = {
  class: 'fas fa-shield-alt',
  color: '#40C4FF'
};

const REGION_ICON = {
  class: 'fas fa-globe-americas',
  color: '#40C4FF'
};

@State<TournamentStateModel>({
  name: 'tournament',
  defaults: {
    filters: {
      regions: {
        icon: REGION_ICON,
        options: [
          {
            label: 'ANY REGION',
            image: '',
            value: '',
            selected: true,
            default: true
          },
          {
            label: 'NA EAST',
            image: '',
            value: 'na-east',
            selected: false
          },
          {
            label: 'NA WEST',
            image: '',
            value: 'na-west',
            selected: false
          },
          {
            label: 'EUROPE',
            image: '',
            value: 'europe',
            selected: false
          },
          {
            label: 'OCEANIC',
            image: '',
            value: 'oceanic',
            selected: false
          }
        ]
      },
      formats: {
        icon: FORMAT_ICON,
        options: [
          {
            label: 'ANY FORMAT',
            image: null,
            value: '',
            selected: true,
            default: true
          },
          {
            label: 'SINGLE ELIMINATION',
            image: null,
            icon: null,
            value: 'single-elimination',
            selected: false
          },
          {
            label: 'ROUND ROBIN',
            image: null,
            icon: null,
            value: 'round-robin',
            selected: false
          },
          {
            label: 'CONSOLATION',
            image: null,
            icon: null,
            value: 'consolation',
            selected: false
          },
          {
            label: 'LADDER SERIES',
            image: null,
            icon: null,
            value: 'ladder-series',
            selected: false
          }
        ]
      }
    },
    tournaments: [
      {
        name: 'The First Tournament',
        slots: 12,
        startTime: new Date(),
        endTime: new Date(),
        game: 'fortnite'
      },
      {
        name: 'The Second Tournament',
        slots: 16,
        startTime: new Date(),
        endTime: new Date(),
        game: 'league-of-legends'
      },
      {
        name: 'The Third Tournament',
        slots: 12,
        startTime: new Date(),
        endTime: new Date(),
        game: 'fortnite'
      },
      {
        name: 'The Fourth Tournament',
        slots: 16,
        startTime: new Date(),
        endTime: new Date(),
        game: 'league-of-legends'
      },
      {
        name: 'The First Tournament',
        slots: 12,
        startTime: new Date(),
        endTime: new Date(),
        game: 'fortnite'
      },
      {
        name: 'The Second Tournament',
        slots: 16,
        startTime: new Date(),
        endTime: new Date(),
        game: 'league-of-legends'
      },
      {
        name: 'The Third Tournament',
        slots: 12,
        startTime: new Date(),
        endTime: new Date(),
        game: 'fortnite'
      },
      {
        name: 'The Fourth Tournament',
        slots: 16,
        startTime: new Date(),
        endTime: new Date(),
        game: 'league-of-legends'
      }
    ]
  }
})
export class TournamentState {
  @Selector()
  public static filters(state: TournamentStateModel) {
    const props = Object.getOwnPropertyNames(state.filters);
    const model = {};
    for (const prop of props) {
      const filter = state.filters[prop];
      const selected = filter.options.find(opt => opt.selected);
      selected.icon = filter.icon;

      model[prop] = {
        options: filter.options,
        selected: selected
      };
    }
    return model;
  }

  @Selector()
  public static tournaments(state: TournamentStateModel) {
    return state.tournaments;
  }

  @Action(SetRegionFilter)
  public setRegionFilter(
    context: StateContext<TournamentStateModel>,
    action: SetRegionFilter
  ) {
    const state = context.getState();

    state.filters.regions.options.forEach(opt => {
      if (opt.value === action.region) opt.selected = true;
      else opt.selected = false;
    });

    context.patchState(state);
  }

  @Action(SetFormatFilter)
  public setFormatFilter(
    context: StateContext<TournamentStateModel>,
    action: SetFormatFilter
  ) {
    const state = context.getState();

    state.filters.formats.options.forEach(opt => {
      if (opt.value === action.format) opt.selected = true;
      else opt.selected = false;
    });

    context.patchState(state);
  }
}
